import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface CheckmarkIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const CheckmarkIcon = ({ color = RoutalPalette.primary40, style = {} }: CheckmarkIconProps) => {
  return (
    <SvgIcon viewBox="0 0 11 10" fill="none" style={{ fill: `none`, width: `15`, height: `14`, ...style }}>
      <path
        id="Vector"
        d="M0.5 6.53842L2.80769 8.84612L10.5 1.15381"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
